<template>
  <div class="sign-sa">
    <div class="sign">
      <h4>
        <span>Sign the service agreement</span>
        <a href="javascript:;" target="_blank" class='hide'>Service agreement FAQs</a>
      </h4>
      <div class="sign_cont">
        <div class="agreement">
          <div class="cont_agree">
            <img :src="saImgPath" alt="">
          </div>
        </div>
        <a class="annex-link" :href="annexPath" target="_blank">Annex</a>
        <div class="checkInput" v-show='!complete'>
          <InputCheckbox @checkFn="changeCheck" :isCheck="isCheck"></InputCheckbox>
          <p class="checkCont">By clicking here, I indicate that I have read, understood, and accepted the terms <br>and conditions of my service agreement with 51Talk EnglishInternational Limited.</p>
        </div>
        <div class='clearfix c_wrap' :class="[{hide: !isCheck}, 'line_f']" v-show='!complete && isCheck'>
          <input v-model.trim='first_name' type="text" placeholder="First Name＊">
          <input v-model.trim='full_name' type="text" placeholder="Last Name＊">
          <el-select v-model="country" filterable placeholder="Nationality">
            <el-option v-for="(key, val) in datas" :key="val" :label="key" :value="val">
            </el-option>
          </el-select>
          <div class="textInput clearfix">
            <input type="text" v-model.trim='nick_name' placeholder="Teacher Name*">
            <span class="detect" @click="detectFn">Detect Availability</span>
            <p :class="[{great: great}, 'state_notice']">{{message}}</p>
            <div class="attention">
              <i></i>
              <p>
                <b></b>Teacher Naming Standards <br>·Must be unique and not yet used by other teachers in the system.
                <br>·Must consist of two full names, not initials (i.e. Aaron James). <br>·May contain your original name or a name that sounds like it but the second name must be an alias.<br>·Must not sound funny or awkward (i.e. Superman, Bubble Tea).<br>·Videos, introductions, and Skype accounts must use the same teacher name.</p>
            </div>
          </div>
          <div class='btn_wrap'>
            <a @click='setSa' :class="{'dis': !canSetSa}">I Agree</a>
          </div>
        </div>
        <div class='complete' v-show='complete'>
          <h1>
            <span></span>Agreed</h1>
          <p class='name'>{{first_name}} {{full_name}} / {{datas[country]}} / {{nick_name}}</p>
          <p class='date'>{{date}}</p>
        </div>
      </div>
    </div>
    <div class="next_cont">
      <a class="button" :class='{cancel: !complete}' @click='next' href="javascript:;">Next</a>
    </div>
  </div>
</template>

<script>
import InputCheckbox from '@common/input_check_box'

export default {
  props: {},
  data() {
    return {
      isCheck: false,
      first_name: '',
      full_name: '',
      nick_name: '',
      country: '',
      datas: [],
      complete: false,
      date: '',
      great: false,
      message: '',
      has_set: false,
      has_set_ok: false,
      click_br: true,
      saImgPath: '', //SA协议的图片的路径
      annexPath: '', //工资合同地址
      saId: ''
    }
  },
  computed: {
    canSetSa() {
      return (
        !!this.isCheck &&
        !!this.first_name &&
        !!this.full_name &&
        !!this.nick_name
      )
    }
  },
  components: {
    InputCheckbox
  },
  methods: {
    next() {
      if (!this.complete) return

      const loading = this.$loading()

      this.$http
        .get('/Boarding/boardingNext')
        .then(d => {
          loading.close()

          if (d.data.code == '75000') {
            this.$message.success('save success.')
            this.$router.replace('/online_pending')
          } else {
            this.$message.error(d.data.message)
          }
        })
        .catch(err => {
          loading.close()
          console.log(err)
          this.$message.error('server error')
        })
    },
    detectFn: function() {
      //检查老师名称是否存在
      let _this = this
      let formdata = new URLSearchParams()
      if (this.nick_name == '') return
      formdata.append('nick_name', _this.nick_name)
      this.axios
        .post('/Boarding/checkName', formdata)
        .then(function(d) {
          _this.has_set = true
          if (d.data.code == 75070) {
            _this.message = d.data.message
            _this.great = true
            _this.has_set_ok = true
          } else if (d.data.code == 75071) {
            _this.message = d.data.message
            _this.great = false
            _this.has_set_ok = false
          }
        })
    },
    changeCheck: function(isCheck) {
      this.isCheck = isCheck
    },
    sa_time(time) {
      let date = ''
      let months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
      let hh = time.getHours() < 10 ? '0' + time.getHours() : time.getHours()

      let mm =
        time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()

      let ss =
        time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds()

      return (
        months[time.getMonth()] +
        ' ' +
        time.getDate() +
        ',' +
        time.getFullYear() +
        ' ' +
        hh +
        ':' +
        mm +
        ':' +
        ss
      )
    },
    setSa() {
      let _this = this

      if (!this.canSetSa) return

      if (!_this.has_set) {
        this.$message.error(
          'Please click on "Detect Availablity" to check if your teacher name is available.'
        )
        return
      }

      if (!_this.has_set_ok) {
        this.$message.error(
          'Oops. This name is already taken. Please choose another one.'
        )
        return
      }

      var params = new URLSearchParams()

      params.append('sa_signed', _this.isCheck ? 'yes' : 'no')

      params.append('first_name', _this.first_name)

      params.append('full_name', _this.full_name)

      params.append('nationality', _this.country)

      params.append('nick_name', _this.nick_name)

      params.append('sa_id', _this.saId)

      const loading = this.$loading()

      this.axios
        .post('/Personal/setSa', params)
        .then(function(d) {
          loading.close()

          if (d.data.code == '75000') {
            _this.complete = true

            _this.date = d.data.res.show_sa_signed_time
          } else {
            _this.$message.error(d.data.message)
          }
        })
        .catch(err => {
          loading.close()
          _this.$message.error('server error')
        })
    }
  },
  created: function() {
    this.$http.get('/Personal/getServiceAgreement').then(d => {
      console.log(d)
      if (d.data.code == '75000') {
        this.saImgPath = d.data.res.url
        this.annexPath = d.data.res.annex_url
        this.saId = d.data.res.id
        console.log(this.saImgPath, this.saId)
      } else {
        this.$message.error('service error.')
      }
    })

    this.$http
      .get('/common/getConfig?key=nationality')
      .then(function(d) {
        if (d.data.code == 75000) {
          this.datas = d.data.res.nationality
        } else {
          this.$message.error('service error.')
        }
        this.$http.get('/Boarding/getTutor').then(d => {
          if (d.data.code == '75000') {
            let sa_signed = d.data.res.info.sa_signed

            let first_name = d.data.res.info.pso_first_name

            let full_name = d.data.res.info.pso_full_name

            let country = d.data.res.info.nationality

            let nick_name = d.data.res.info.nick_name

            if (country) {
              this.country = country
            }

            if (sa_signed == 'yes') {
              //已经签过sa

              this.complete = true

              this.first_name = first_name

              this.full_name = full_name

              this.nick_name = nick_name

              this.date = d.data.res.info.show_sa_signed_time
            }
          }
        })
      })
  },
  watch: {
    nick_name(o, n) {
      if (this.has_set) {
        this.has_set = false
        this.has_set_ok = false
        this.message = ''
      }
    }
  }
}
</script>

<style lang='less' scoped>
.sign-sa {
  .sign {
    & > h1 {
      padding-top: 55px;
      font-size: 16px;
      color: #1e1e1e;
      font-weight: bold;
    }
    h4 {
      padding-top: 46px;
      height: 24px;
      margin-bottom: 34px;
      span {
        font-size: 24px;
        font-weight: bold;
        color: #febf00;
        float: left;
        margin-right: 26px;
      }
      a {
        float: right;
        color: #009cff;
        font-size: 14px;
        padding-top: 5px;
        &:hover {
          text-decoration: underline;
        }
      }
      .adopt {
        font-size: 14px;
        color: #fd4c6e;
        float: left;
        padding-top: 4px;
        line-height: 16px;
        & > b {
          float: left;
          width: 16px;
          height: 16px;
          margin-right: 4px;
          background: url('~@img/adopt.png') 0 0 no-repeat;
        }
        &.adopt_Complete {
          color: #29b36a;
          b {
            background-position: 0 -16px;
          }
        }
      }
    }
    .sign_cont {
      background-color: #f7f7f7;
      padding: 30px;
      border-radius: 8px;
      .complete {
        text-align: center;
        h1 {
          font-size: 24px;
          color: #29b36a;
          span {
            display: inline-block;
            margin-right: 10px;
            width: 36px;
            height: 36px;
            vertical-align: middle;
            background: url('~@img/complete.png') no-repeat 0 0;
          }
        }
        p.name {
          margin-top: 30px;
          font-size: 24px;
          color: #1e1e1e;
        }
        p.date {
          margin-top: 20px;
          font-size: 14px;
          color: #1e1e1e;
        }
      }
      .agreement {
        padding: 40px 10px 30px 24px;
        background-color: #fff;
        margin-bottom: 30px;
      }
      .cont_agree {
        overflow: auto;
        height: 324px;
        padding: 0 28px 0 21px;
        img {
          width: 100%;
          margin: 0 auto;
        }
      }
      .annex-link {
        text-decoration: underline;
      }
      .checkInput {
        padding-left: 170px;
        padding-bottom: 28px;
      }
      .input_check_box {
        float: left;
      }
      .checkCont {
        margin-left: 32px;
        line-height: 18px;
        font-size: 14px;
        color: #1e1e1e;
      }
      .c_wrap {
        & > input:nth-child(1) {
          margin-left: 97px;
        }
        .textInput {
          z-index: 100;
          position: relative;
          margin-left: 20px;
          input {
            float: none;
            margin-bottom: 0;
            margin-right: 0;
          }
          span.detect {
            width: 132px;
            position: absolute;
            height: 38px;
            line-height: 40px;
            background-color: #fcc800;
            color: #1e1e1e;
            font-size: 14px;
            text-align: center;
            border-radius: 0 8px 8px 0;
            top: 0;
            right: 0;
            cursor: pointer;
          }
          p.state_notice {
            padding: 5px 0 5px 15px;
            color: #fd4c6e;
            font-size: 13px;
            &.great {
              color: #01b101;
            }
          }
        }
        .attention {
          position: absolute;
          right: 0;
          top: 0;
          i {
            position: absolute;
            right: -31px;
            top: 12px;
            width: 16px;
            height: 16px;
            background: url(~@img/step.png) 0 -108px no-repeat;
          }
          p {
            width: 373px;
            padding: 10px;
            position: absolute;
            left: -217px;
            top: -186px;
            border: 1px solid #ccc;
            border-radius: 5px;
            background-color: #fff;
            font-size: 13px;
            color: #999;
            line-height: 17px;
            display: none;
            b {
              position: absolute;
              left: 231px;
              top: 173px;
              width: 16px;
              height: 8px;
              background: url(~@img/step.png) -20px -112px no-repeat;
            }
          }
        }
        .attention:hover {
          p {
            display: block;
          }
        }
      }
      .line_f {
        padding-top: 30px;
        border-top: 1px solid #e0e0e0;
        & > * {
          float: left;
        }
        .btn_wrap {
          width: 100%;
          a {
            display: block;
            width: 235px;
            height: 38px;
            line-height: 38px;
            background-color: #fff;
            border: 1px solid #fcc800;
            border-radius: 10px;
            color: #ffb400;
            text-align: center;
            font-size: 18px;
            outline: none;
            margin: 0 auto;
            margin-top: 30px;
            cursor: pointer;
            &:hover {
              background-color: rgba(255, 255, 255, 0.8);
            }

            &.dis {
              cursor: not-allowed;
              color: #adadad;
              border-color: #ccc;
            }
          }
        }
        input {
          float: left;
          box-sizing: border-box;
          width: 380px;
          height: 38px;
          color: #1e1e1e;
          border: 1px solid #cccccc;
          margin-right: 20px;
          margin-bottom: 20px;
          border-radius: 10px;
          outline: none;
          padding-left: 15px;
          box-shadow: 0 2px 2px 1px #ebebeb inset;
        }
        :-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #97a8cc;
          font-size: 14px;
        }
        ::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #97a8cc;
          font-size: 14px;
        }
        input:-ms-input-placeholder {
          color: #97a8cc;
          font-size: 14px;
        }
        input::-webkit-input-placeholder {
          color: #97a8cc;
          font-size: 14px;
        }
        .instructions {
          float: left;
          font-size: 14px;
          color: #525252;
          line-height: 16px;
          padding-top: 2px;
        }
        input:focus {
          border-color: #fcc800;
          box-shadow: 0 2px 2px 1px #fff2cc inset;
        }

        .el-select {
          margin-left: 97px;
          width: 380px;
          height: 38px;
        }
      }
    }
  }
  .next_cont {
    height: 46px;
    text-align: center;
    margin-top: 20px;
    a {
      width: 337px;
      height: 46px;
      text-align: center;
      line-height: 46px;
      border: none;
      border-radius: 10px;
      font-size: 24px;
      color: #fff;
      background-color: #ccc;
      display: inline-block;
      &.button {
        color: #1e1e1e;
        background-color: #fcc800;
      }
      &.cancel {
        background: #cccccc;
        color: #fff;
        cursor: default;
      }
    }
  }

  .hide {
    display: none;
  }
}
</style> 


// WEBPACK FOOTER //
// sign_sa.vue?38eaf040